/** Importe guardado en céntimos, como lo lee el restaurante («84,50 €»). */
export function formatCents(cents: number, currency = "EUR"): string {
  return new Intl.NumberFormat("es-ES", { style: "currency", currency }).format(cents / 100);
}
